
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action, namespace } from 'vuex-class';
// components
import Login from '@/components/Login.vue'; // @ is an alias to /src
import Register from '@/components/Register.vue';
import EditUser from "@/components/UserManagement/EditUser.vue";
import VCardDlg from './VCardDlg.vue';
import { VCardInfoVm } from '@/interfaces/VCardInfoVm';

const auth = namespace('auth');
const globals = namespace("globals");

@Component({
  components: {
      Login,
      Register,
      EditUser,
      VCardDlg
  }
})
export default class AvatarMenu extends Vue {
    @auth.Action Logout: any;
    @auth.Getter loginName!: string;
    @auth.Getter loggedIn!: boolean;
    @globals.Getter vCard!: VCardInfoVm;

    showMenu: boolean = false;
    showLoginDialog: boolean = false;
    showRegisterDlg: boolean = false;
    showProfileDlg: boolean = false;
    showVCardDlg: boolean = false;

    openLoginDialog() {
      // value is use as trigger => just invert it
      this.showLoginDialog = !this.showLoginDialog;
    }

    async onLogout() {
        await this.Logout();
    }

    goToRegistration() {
      this.showLoginDialog = false;
      this.showRegisterDlg = true;
    }

    get showVCardMenuItem() {
      if (this.loggedIn) {
        return true;
      }

      if (this.vCard) {
        return true;
      }

      return false;
    }
}
